import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogHeader,
    DialogTitle,
    DialogTrigger,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { useState } from "react";
import SupplierOnboardLinkForm from "@/v2/components/pages/supplier/OnboardLinkForm";

export default function GenerateSupplierOnboardLink() {
    const [open, setOpen] = useState(false);

    return (
        <Dialog open={open} onOpenChange={(value) => setOpen(value)}>
            <DialogTrigger asChild>
                <Button>Generate Supplier Onboard Link</Button>
            </DialogTrigger>
            <DialogContent>
                <DialogHeader>
                    <DialogTitle className="text-2xl font-semibold tracking-tight">
                        Generate Supplier Onboard Link
                    </DialogTitle>
                    <DialogDescription className="text-sm text-muted-foreground">
                        Fill in the details to generate a link for supplier
                        onboarding
                    </DialogDescription>
                </DialogHeader>
                <SupplierOnboardLinkForm closeOnSave={() => setOpen(false)} />
            </DialogContent>
        </Dialog>
    );
}
